import { t } from '../messages';
import type { ExternalAccessForm } from '../lib/rpc';
/** Post credentials in the new tab, never in a URL, persistent storage or query cache. */
export function submitExternalForm(
  popup: Window,
  form: ExternalAccessForm,
  hostname: string | null,
): void {
  const url = new URL(form.url);
  if (!hostname || url.origin !== 'https://' + hostname || url.username || url.password || url.hash)
    throw new Error(t('environments.error'));
  const document = popup.document;
  const element = document.createElement('form');
  element.method = 'POST';
  element.action = url.href;
  const meta = document.createElement('meta');
  meta.name = 'referrer';
  meta.content = 'strict-origin';
  document.head.append(meta);
  for (const [name, value] of Object.entries(form.fields)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    element.append(input);
  }
  document.body.replaceChildren(element);
  // A field named "submit" must not shadow the native form method.
  HTMLFormElement.prototype.submit.call(element);
}
